@if(currentSection === 'deviceCompatibility'){
  <div>
    <div class="flex-1 px-300-rem py-250-rem">
      <div class="rounded-050">
        <div class="flex flex-col space-y-050-rem">
          <h1 class="text-headline-md-weight-medium text-action-fg-secondary">
            Compatible device software versions
          </h1>
          <p class="text-container-fg-muted text-label-md-weight-regular">
            Please define the compatible device software versions for the firmware package.
          </p>
        </div>
        <div
          class="border border-container-border-default rounded-050 mt-6 bg-container-bg-default max-w-211.5">
          <div class="max-w-114 py-150-rem">
            @for(input of inputs; let i = $index; track input.id){
              <div class="flex gap-2 px-4 items-center relative" [ngClass]="i > 0 ? 'mt-400-rem' : ''">
                <div>
                  <label class="text-[rgb(107,114,128)]" for="cp">CP</label>
                </div>

                <div class="flex-1 relative">
                  <div class="my-050-rem w-full">
                    <input
                      id="cp{{input.id}}"
                      type="text"
                      name="name{{input.id}}"
                      [(ngModel)]="input.value"
                      required
                      (ngModelChange)="checkVersion(input)"
                      class="border py-100-rem rounded-075 px-075-em w-full placeholder-container-fg-muted text-body-lg-weight-regular focus:outline-none focus:ring-0"
                  [ngClass]="{
  'border-feedback-fg-error': input.isExceeding && showError(),
  'border-feedback-fg-warning': input.isVersionIdMismatch && showError(),
  'border-input-border-default': 
      !(input.isExceeding && showError()) &&
      !(input.isVersionIdMismatch && showError())
}"
                      placeholder="Enter value here" />
                  </div>
                  @if(input.isExceeding && showError()){
                    <div
                      class="absolute -bottom-12.5 text-label-sm-weight-regular mt-050-rem text-action-bg-error">
                      <div class="flex items-center gap-050-em">
                        <i
                        class="icon_marina_ui_CrossContainedOutlined text-feedback-fg-error text-[1rem]"></i>
                        <p>
                          The version you entered matches or exceeds the firmware version in this package.
                          Only firmware versions older than the uploaded file are allowed.
                        </p>
                      </div>
                    </div>
                  } @else if(input.isVersionIdMismatch && showError()){
                    <div
                      class="absolute -bottom-13 text-label-sm-weight-regular mt-050-rem text-feedback-fg-warning">
                      <div class="flex items-center gap-050-em">
                        <i class="icon_marina_ui_WarningOutlined text-feedback-fg-warning text-[1rem]"></i>
                        <p>
                          The id version ({{ input.value }}) differs from the uploaded firmware's id
                          version ({{version}}). Please verify this is intentional.
                        </p>
                      </div>
                    </div>
                  } @else {
                    <div
                      class="absolute -bottom-7.5 text-label-sm-weight-regular mt-025-rem"
                      [ngClass]="(!input.value || input.namePatternInvalid) && error ? 'text-action-bg-error' : 'text-container-fg-muted'">
                      Format: &lt;version id&gt;-&lt;hardware version&gt;, &lt;major version&gt;.&lt;minor
                      version&gt;.&lt;development version&gt;, e.g. 450-3,5.4.635
                    </div>
                  }
                </div>

                <div class="absolute -right-200-rem">
                  @if (i > 0) {
                    <button
                      aria-label="Remove input"
                      class="cursor-pointer"
                      (click)="removeInput(i)"
                      type="button">
                      <i class="icon_marina_ui_DeleteOutlined text-headline-lg-weight-regular"></i>
                    </button>
                  }
                </div>
              </div>
            }

            <div class="mt-17.5">
              <button
                aria-label="Add input"
                type="button"
                (click)="addNewInput()"
                class="rounded-full cursor-pointer bg-action-bg-default p-075-rem w-fit flex mx-auto">
                <i
                class="icon_marina_ui_PlusOutlined text-action-fg-inverted-permanent text-headline-lg-weight-regular"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      @if(error) {
        <div
          class="flex items-center text-label-sm-weight-regular gap-025-em text-feedback-fg-error mt-025-em">
          <i class="icon_marina_ui_CrossContainedOutlined text-feedback-fg-error text-[1rem]"></i>
          <span> {{ error }}</span>
        </div>
      }
    </div>
  </div>
}
